/* eslint-disable */
export default {
    LOG_OUT: 'Log out',
    LOGIN: 'Login',
    GET_A_MAP_EXPERT: 'Get a map expert',
    MY_ACCOUNT: 'My account',
    MY_ACCOUNT_DESC: 'You can change your settings',
    SUBSCRIPTION: 'Subscription',
    PASSWORD: 'Password',
    LANGUAGE: 'Language',
    AVAILABLE_LANGUAGES: 'Available languages',
    YOU_HAVE_NO_PASSWORD: 'You have no password',
    YOU_HAVE_NAME: 'You are running a {0} version of Mapheim',
    SUBSCRIBE_ACTION: 'Subscribe',
    MANAGE_SUBSCRIPTION: 'Manage subscription',
    CANCELLED_SUBSCRIPTION: 'Your subscription has been canceled and it will be deactivated at the end of your billing period',
    RENEW_SUBSCRIPTION: 'Renew subscription',
    RESUBSCRIBE: 'Resubscribe',
    VIEW_PAST_INVOICES: 'View past invoices',
    SUBSCRIBE_NOT_PAID: 'Your subscription could not be paid. Please review your payment details and repeat the payment',
    REVIEW_PAYMENT: 'Review payment',
    YOUR_MAPS: 'Your maps',
    EDIT_CONTENT: 'Edit content',
    ADVANCED_EDITOR: 'Advanced editor',
    CUSTOM_URL: 'Custom URL',
    UNNAMED_MAP: 'Unnamed map',
    EDIT: 'Edit',
    WELCOME: 'Welcome',
    WELCOME_DESC: 'Enjoy working with your maps!',
    DO_YOU_WANT_NEW_MAP: 'Do you want a new map?',
    UPGRADE_ACTION: 'Upgrade',
    CREATE_ACTION: 'Create',
    UPGRADE_EXPERIENCE: 'Upgrade your experience',
    UPGRADE_EXPERIENCE_DESC: 'Get more from your maps',
    NEED_HELP: 'Need help?',
    LET_US_KNOW: 'Let us know',
    CONTACT_ACTION: 'Contact',
    MO: 'mo.',
    SUB1: 'Creator',
    SUB1_DESC: 'For enthusiastic creators',
    VIEWS_PER_MONTH: '{0} views / month',
    MARKERS_PER_MAP: '{0} markers / map',
    X_MAPS: '{0} maps',
    DEDICATED_SUPPORT: 'Dedicated support',
    MANAGE_ACTION: 'Manage',
    DOWNGRADE_ACTION: 'Downgrade',
    SUB2: 'Pro',
    SUB2_DESC: 'For professional usage',
    UNLIMITED_MARKERS: 'Unlimited markers',
    UNLIMITED_MAPS: 'Unlimited maps',
    SUB3: 'Custom',
    SUB3_DESC: 'For any map needs',
    SUB3_TEXT1: 'Do you need more views, special features or help with creating your map?',
    SUB3_TEXT2: 'We have done maps for theme parks, conferences, tourism, festivals and many more industries. Let us know',
    CONTACT_US: 'Contact us',
    PREVIEW_MAP: 'Preview map',
    SHARE_ACTION: 'Share',
    GET_ACCESS: 'Get access',
    LOGIN_TO_BECOME: 'Login to become a true map creator or',
    CREATE_A_MAP: 'create a map',
    AS_A_GUEST: 'as a guest',
    REGISTER_CREATOR: 'Register to become a true map creator',
    REGISTRATION: 'Registration',
    USING_SOCIALS: 'Using social media',
    USING_MAIL: 'Using e-mail',
    EMAIL_OR_USER: 'Email or username',
    FORGOT_PASSWORD: 'Forgot password',
    LOGIN_ACTION: 'Login',
    ERROR_USER_NOT_FOUND: 'User not found',
    ERROR_WRONG_PASSWORD: 'Wrong password',
    ERROR_USER_BANNED: 'User banned',
    ERROR_EMAIL_NOT_VERIFIED: 'Email not verified',
    ERROR_LOGIN: 'Error while logging in',
    VERIFICATION_SENT1: 'The verification link was sent to your email address',
    VERIFICATION_SENT2: 'Check your inbox and spam folder and click the link to finish the registration',
    EMAIL: 'Email',
    CONFIRM_PASSWORD: 'Confirm password',
    INVALID_EMAIL: 'Email is invalid',
    PASSWORD_NOT_STRONG: 'New password is not strong enough or passwords are not equal. It needs to be at least 6 characters long',
    EMAIL_USED: 'User with this email is already registered',
    ERROR_REGISTRATION: 'Error while registering new user',
    MAP_NOT_ACCESSIBLE: 'This map cannot be accessed',
    MAP_NOT_ACCESSIBLE_DESC: 'Please contact the owner of the map to make the map available again',
    RETRIEVE_ACCESS: 'Retrieve access',
    RETRIEVE_ACCESS_DESC: 'Change your password to become a true map creator',
    SEND_RESET_LINK_ACTION: 'Send the link',
    RESET_LINK_SENT: 'An email with a recovery link was sent to your email address. Please check your inbox and spam folder',
    ERROR_SENT_LINK: 'Error while sending the reset link',
    EMAIL_VERIFIED: 'E-mail verified',
    EMAIL_VERIFIED_DESC: 'Login and start creating',
    RESET_PASSWORD: 'Reset password',
    RESET_PASSWORD_DESC: 'Change password to become a true map creator',
    INVALID_LINK: 'Invalid link',
    ERROR_RESET_CODE: 'The reset code expired. Please send a new reset code',
    ERROR_RESETTING: 'Error while setting up new password',
    NEW_PASSWORD: 'New password',
    SET_NEW_PASSWORD: 'Set new password',
    HEADER: 'Header',
    NO_HEADER: 'No header',
    TITLE: 'Title',
    DESCRIPTION: 'Description',
    SELECT_ACTION: 'Select',
    CONTENT: 'Content',
    CONTENT_DESC: 'You can also add variety of content cards to your marker (recommended)',
    POST_URL: 'Post URL',
    POST_ID: 'Post ID',
    VIDEO_URL: 'Video URL',
    ADD_FIRST_CARD: 'Add a first card',
    LINK: 'Link',
    CONFIRM_DELETE_LINK: 'Do you want to delete this link?',
    ADD_LINK: 'Add link',
    ADD_ANOTHER_LINK: 'Add another link',
    NAME: 'Name',
    TYPE: 'Type',
    GUIDE: 'Guide',
    OLD_GUIDE: 'Old guide',
    SHARE_THE_LINK: 'Share the link',
    COPY_MAP_ID: 'Map ID for Wordpress Plugin',
    COPY_MAP_ID_ACTION: 'Copy Map ID',
    COPY_MAP_ID_CLIPBOARD: 'Map ID copied to clipboard',
    LINK_COPIED_CLIPBOARD: 'Link copied to clipboard',
    GUIDE_COLORS_ACCENT1: 'Main color',
    CUSTOM: 'Custom',
    SAVE: 'Save',
    ALL_SAVED: 'All saved',
    COPY_URL_ACTION: 'Copy URL',
    GENERATE_QR_CODE: 'Generate QR code',
    DOWNLOAD_QR_ACTION: 'Download QR',
    EMBED_ON_YOUR_SITE: 'Embed on your site',
    COPY_HTML_ACTION: 'Copy HTML',
    HTML_COPIED_CLIPBOARD: 'HTML copied to clipboard',
    HISTORY: 'History',
    MARKERS: 'Markers',
    LOCATION: 'Location',
    LOADING: 'Loading',
    NOTHING_FOUND: 'Nothing found',
    PLEASE_WRITE_CHARACTERS: 'Please write at least 3 characters',
    MOUSE: 'Mouse',
    PIN: 'Pin',
    IMAGE: 'Image',
    TEXT: 'Text',
    DRAW: 'Draw',
    DIRECTION: 'Direction',
    LINE: 'Line',
    POLYGON: 'Polygon',
    WALL_LINE: '3D Wall',
    WALL_FILL: '3D Wall (Filled)',
    REACT: 'React',
    CHATGPT: 'ChatGPT',
    UPLOAD_ACTION: 'Upload',
    PROPERTIES: 'Properties',
    INTERACTIVITY: 'Interactivity',
    MAP_SETTINGS: 'Map settings',
    PRIVACY: 'Privacy',
    PRIVACY_DESC: 'Private maps can not be shared with anyone',
    GPS_POSITION: 'GPS position',
    ENABLED: 'Enabled',
    DISABLED: 'Disabled',
    BUBBLE_DESC: 'Clicking on interactive marker shows a small bubble. Recommended for a minimum amount of content',
    MINI_DESC: 'Clicking on interactive marker shows a popup. Recommended for a small amount of content',
    STYLE1_DESC: 'Clicking on interactive marker shows a sidebar. Recommended forany amount of content',
    PANEL: 'Panel',
    POPUP: 'Popup',
    BUBBLE: 'Bubble',
    PUBLIC: 'Public',
    PRIVATE: 'Private',
    MAP_STYLE: 'Map style',
    FILL_COUNTRIES: 'Fill countries',
    REGISTER_PROMPT: 'Register to save your progress',
    GET_MORE_PROMPT: 'Get more visits and unlimited markers by upgrading to Pro mode',
    CONTACT_PROMPT: 'Do you want an early advanced editor access, or need even more views?',
    UNLOCK_PROMPT: 'Unlock all the features and increase your map visits with the Creator or Pro mode',
    UPGRADE: 'Upgrade',
    MAP_VISITS_LIMIT: 'Map visits limit',
    MARKER_LIMIT: 'Marker limit',
    ADVANCED_EDITOR_ACCESS: 'Advanced editor access',
    REGISTER_ACTION: 'Register',
    NO: 'No',
    YES: 'Yes',
    SYMBOL: 'Symbol',
    YOUR_IMAGE: 'Your image',
    SEARCH: 'Search',
    SEARCH_ON_MAP: 'Search on map',
    MORE: 'More',
    BACKGROUND: 'Background',
    CONTROLS: 'Controls',
    CLONE: 'Clone',
    ORDER: 'Order',
    TOP: 'Top',
    BOTTOM: 'Bottom',
    EMOJI: 'Emoji',
    SEARCH_GIFS: 'Search GIFs',
    DELETE: 'Delete',
    TRANSPORTATION: 'Transportation',
    COORDINATES: 'Coordinates',
    POINT_X: 'Point {0}',
    POSITION: 'Position',
    GROUND_COLOR: 'Floor',
    STYLE: 'Style',
    COLOR: 'Color',
    SIZE: 'Size',
    POSITION_DESC: 'Click anywhere on the map to change the position',
    TRANSFORM: 'Transform',
    ROTATE: 'Rotate',
    SCALE: 'Scale',
    BORDER_SIZE: 'Border size',
    OPACITY: 'Opacity',
    BORDER_COLOR: 'Border color',
    DASHED: 'Dashed',
    HEIGHT: 'Height',
    BASE_HEIGHT: 'Base height',
    WIDTH: 'Width',
    DIRECTION_ADD1: 'Click anywhere on the map to set a starting point or search for an address',
    DIRECTION_ADD2: 'Click again to set the destination or search for an adress (or Esc to cancel)',
    ICON_ADD: 'Click anywhere on the map or search for an address to add a Pin. The pin always keeps the same size',
    VARIANT_ICON_ADD: 'Click anywhere on the map or search for an address to add a Pin. The pin keeps the same size, but its style changes based on the zoom level',
    IMAGE_ADD: 'Click anywhere on the map to upload an image, or drag & drop one of the symbols or images from the gallery',
    TEXT_ADD: 'Click anywhere on the map to add a text',
    LINE_ADD: 'Start clicking on the map to draw a line. Press Enter to finish (or Esc to cancel)',
    POLYGON_ADD: 'Start clicking on the map to draw a polygon. Press Enter to finish (or Esc to cancel)',
    WALL_ADD: 'Start clicking on the map to draw a 3D Wall. Press Enter to finish (or Esc to cancel)',
    ADDRESS_SEARCH: 'Address search',
    STARTING_POINT: 'Starting point',
    DESTINATION: 'Destination',
    GALLERY: 'Gallery',
    POLYGON_ADD2: 'Polygons can be made invisible and still trigger on-click actions (Beneficial especially for Image maps)',
    ZOOM_IN_MORE: 'Zoom in more to draw a wall',
    LABEL: 'Label',
    ICON: 'Icon',
    INTERACTIVITY_PROMPT: 'Define what people see when they click on the marker',
    CREATE_INTERACTIVITY_ACTION: 'Create interactivity',
    CONFIRM_SAVE: 'Do you want to save your changes?',
    CONFIRM_REMOVE_INTERACTIVITY: 'Do you want to remove this interactivity?',
    SAVING: 'Saving',
    REFRESH_PREVIEW: 'Refresh preview',
    SHOW_PREVIEW: 'Show preview',
    REMOVE_INTERACTIVITY: 'Remove interactivity',
    MAX_LENGTH_TEXT_MARKER: 'You have reached max text length of 1000 characters',
    MAP_ROTATION: 'Map rotation',
    PITCH_ANGLE: 'Pitch angle (view only)',
    GPX_FILE: 'GPX file',
    GPX_UPLOAD_MESSAGE: 'Upload your GPX File on the right. If the file is unsupported, please write us a message',
    EXPERIMENTAL_FEATURES_MESSAGE: 'You can activate experimental features. This is intended only for experienced creators and testers',
    EXPERIMENTAL: 'Experimental',
    LATITUDE: 'Latitude',
    LONGITUDE: 'Longitude',
    FILE_UPLOAD: 'File upload',
    UNKNOWN_GPX_FILE: 'Unknown GPX file format',
    OPEN_GALLERY: 'Open gallery',
    GALLERY_ALL: 'All',
    GALLERY_YOUR_IMAGES: 'Your images',
    GALLERY_CATEGORY_IMAGES: 'Category images',
    GALLERY_NATURE: 'Nature',
    GALLERY_ANIMALS: 'Animals',
    GALLERY_VEHICLES: 'Vehicles',
    GALLERY_BUILDINGS: 'Buildings',
    GALLERY_FLAGS: 'Flags',
    USE_COMPUTER: 'Use a computer for creating maps',
    USE_COMPUTER_DESC: 'The map editor is not optimized for mobile devices, please use a bigger screen. Do not worry, all the maps created through the editor work great on mobile devices.',
    CONTINUE_ANYWAY: 'Continue anyway',
    GO_TO_HOMEPAGE: 'Go to homepage',
    DELETE_MAP: 'Delete map',
    ADD_FLOOR: 'Add floor',
    FLOORS: 'Floors',
    FLOOR_NR: 'Floor no.',
    ADD_CATEGORY: 'Add category',
    CATEGORIES: 'Categories',
    CATEGORY_NR: 'Category no.',
    VISIBLE_ON_LOAD: 'Visible on load',
    DELETE_MAP_CONFIRM: 'Do you really want to delete this map?',
    DELETE_FLOOR_CONFIRM: 'Do you really want to delete this floor?',
    DELETE_CATEGORY_CONFIRM: 'Do you really want to delete this category?',
    STAND: 'Stand',
    CLICK_ANYWHERE_TO_STAND: 'Click anywhere to add a stand',
    MAP_DELETED: 'Map deleted',
    PIN_IMAGE: 'Pin image',
    LOGO_IMAGE: 'Logo image',
    FILLING: 'Filling',
    FILLING1: 'This option shows only the 3D wall. The last point does not have to be connected to the first one',
    FILLING2: 'This option shows 3D wall and floor. It automatically encloses the area',
    FILLING3: 'This option creates a 3D structure. It automatically encloses the area',
    BOOKING: 'Booking',
    DELETE_BOOKING: 'Delete booking',
    DELETE_BOOKING_CONFIRM: 'Are you sure you want to delete this booking? This action cannot be undone.',
    BOOKING_FIELD_TYPE_CHECKBOX: 'Yes/No',
    BOOKING_FIELD_TYPE_TEXT: 'Text',
    BOOKING_FIELD_TYPE_EMAIL: 'Email',
    BOOKING_EMPTY_INFO: 'No booking exists yet. Below you can see the fields that are being collected.',
    FIELD_REQUIRED: 'This field is required',
    BOOKING_SUBMIT: 'Create reservation',
    BOOKING_SUCCESS_TITLE: 'Your booking is confirmed',
    BOOKING_SUCCESS_MESSAGE: 'Thank you for your booking. You will receive a confirmation email to your email inbox. In case you will not see the email in your inbox,',
    BOOKING_SUCCESS_MESSAGE_CHECK_SPAM: 'please check your spam folder.',
    BOOKING_FAILED_TITLE: 'Your booking could not be created',
    BOOKING_FAILED_MESSAGE: 'It looks like someone booked this stand before you. Please refresh the page and select a stand from the map that is currently free to book. The free stands are marked in green.',
    BOOKING_FULL_TITLE: 'This stand is already booked',
    BOOKING_FULL_MESSAGE: 'Please select a stand from the map that is currently free to book. The free stands are marked in green.',
    BOOKING_CLOSE_DIALOG: 'Close dialog',
    BOOKING_SEE_OTHER_STANDS: 'See the map',
    OR: 'or',
    SEARCH_DETAIL_PLACEHOLDER: 'Search existing interactivity detail',
    REFRESH_PAGE: 'Refresh page',
    EXTERNAL_LINK: 'External link',
    STAND_MARKER1: 'Icon (Zoomed in)',
    STAND_MARKER2: 'Icon (Zoomed out)',
    LOAD_FROM_DETAIL: 'Load from detail',
    DISPLAY_IN_RECTANGLE: 'Display in rectangle',
    COLORED_PIN: 'Colored pin',
    CUSTOM_IMAGE: 'Custom image',
    USE_IN_GUIDE: 'Use in guide',
    LOCATION_NAME: 'Location name',
    DETAILS: 'Details',
    PREVIEW: 'Preview',
    UNSAVED_CHANGES: 'Unsaved changes',
    NO_TITLE: 'No title',
    SHOW_ON_ZOOM: 'Zoom (Show on map)',
    NO_EDIT_IN_MAP_EDITOR: 'This content cannot be edited in Map Editor.',
    GLOBAL_POINTS_EDIT_NOT_SUPPORTED: 'Global Points cannot be editted. Please edit this point directly in your CMS system',
    NEWSFEED: 'Newsfeed',
    EDIT_NEWSFEED_MESSAGE: 'Edit newsfeed message',
    PC_WELCOME_MESSAGE: 'PC Welcome Message',
    TEST_NEWSFEED_NOTIFICATION: 'Test newsfeed notification',
    NEWSFEED_SELECT_USERS: 'Select users',
    NEWSFEED_SEND_TEST_NOTIFICATION: 'Send test notification',
    HEADER_IMAGE: 'Header image',
    NAVIGATION_TITLE: 'Navigation',
    NAVIGATION_DESCRIPTION: 'Define how user gets around your application',
    NAVIGATION_LINK_DESTINATION: 'Link destination',
    NAVIGATION_EXTERNL_URL: 'External URL',
    NAVIGATION_SELECT_LIST: 'Select list',
    NAVIGATION_SELECT_FORM: 'Select form',
    NAVIGATION_SHOW_DYNAMIC_NUMBER: 'Show dynamic number',
    NAVIGATION_CUSTOM_ICON: 'Custom icon',
    NAVIGATION_CUSTOM_TITLE: 'Custom title',
    NAVIGATION_DRAWER_HELP: 'Drawer is divided into primary (large) and secondary (small) buttons. You can set up how many of the buttons are primary',
    NEWSFEED_CREATE_NEW_MESSAGE: 'Create new message',
    NEWSFEED_HELP: 'Updates to share with your visitors. Messages are visible in the Newsfeed section and users are informed about them by Push Notifications',
    NEWSFEED_REMOVE_CONFIRM: 'Are you sure you want to remove the newsfeed message?',
    NEWSFEED_SEND_TO_ALL_CONFIRM: 'Are you sure you want to send notification to all app users?',
    NEWSFEED_NOTIFICATIONS: 'Notifications',
    NEWSFEED_NOTIFICATIONS_SENT: 'Notifications sent',
    ROOMS: 'Rooms',
    VARIANT_ICON: 'Variant icon',
    LIST_VIEW_TYPE: 'List view type',
    CREATE_FORM: 'Create form',
    EDIT_FORM: 'Edit form',
    FORM_TITLE: 'Form title',
    FORM_THANK_YOU_MESSAGE: 'Thank you message',
    FORM_ALLOW_MULTIPLE_SUBMISSIONS: 'Allow multiple submissions',
    FORM: 'Form',
    FORM_FIELDS: 'Fields',
    FORM_FIELD_TITLE: 'Field title',
    FORM_FIELD_TEXT: 'Field text',
    FORM_OPTIONS: 'Options',
    REQUIRED: 'Required',
    EXTERNAL_POINTS: 'External points',
    EXTERNAL_POINTS_DESCRIPTION: 'Add external points from your CMS',
    ENABLE_HIGHLIGHTED_CATEGORY: 'Enable highlighted category',
    TOP_LEFT: 'Top left',
    BOTTOM_RIGHT: 'Bottom right',
    INITIAL_POSITION: 'Initial position',
    ZOOM_SETTINGS: 'Zoom settings',
    VISIBLE_IN: 'Visible in',
    MAP_ORIENTATION: 'Map orientation',
    MIN_MAX_ZOOM: 'Min/Max zoom',
    CURRENT_VIEW_INFO: 'Current view info',
    CURRENT_ZOOM: 'Current zoom',
    LAST_CLICK: 'Last click',
    GLOBAL_MARKER_SETTINGS: 'Global marker settings',
    PIN_SETTINGS: 'Pin settings',
    TEXT_COLOR: 'Text color',
    BACKGROUND_COLOR: 'Background color',
    AUTO_HIDE_LABELS: 'Auto hide labels',
    MARKER_GROUPING: 'Marker grouping',
    MAX_CLUSTERING_ZOOM: 'Max clustering zoom',
    CLUSTER_RADIUS: 'Cluster radius',
    SHOW_LIST_OF_DETAILS: 'Show list of details',
    NO_LIST: 'No list',
    SHOW_LIST: 'Show list',
    SHOW_LIST_WITH_SEARCH: 'Show list with search',
    HOME: 'Home',
    MAP: 'Map',
    PROGRAMME_SHORT: 'Program',
    SPEAKERS: 'Speakers',
    INFO: 'Info',
    MAP_VIEW: 'Map view',
    REMOVE_FILTERS: 'Remove filters',
    LIST_VIEW: 'List view',
    GUIDANCE: 'Guidance',
    HIGHLIGHTED: 'Highlighted',
    EXHIBITORS: 'Exhibitors',
    SURVEY: 'Survey',
    OPEN_ON_YOUR_PHONE: 'Open on your phone',
    INTERACTIVE_MAP: 'Interactive map',
    SHOW_MORE: 'Show more',
    LINKS: 'Links',
    FORM_SUBMIT: 'Submit form',
    FORM_SUBMITTED: 'The form has been successfully submitted',
    INVALID_VALUE: 'Invalid value',
    COMPANIES: 'Companies',
    LIST: 'List',
    FILTERS: 'Filters',
    ZOOM: 'Zoom',
    HIGHLIGHT: 'Highlight',
    UNHIGHLIGHT: 'Unhighlight',
    WEBSITE: 'Website',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    SHOW_ON_MAP: 'Show on map',
    CLOSE: 'Close',
    SHOW_ALL: 'Show all',
    HIDE_ALL: 'Hide all',
    PROGRAMME: 'Programme',
    PLACES: 'Places',
    THIS_IS_INTERACTIVE_MAP: 'This is an interactive map',
    CLICK_ON_INFO: 'Click on the markers to get more information',
    CONTINUE: 'Continue',
    MAPBOX_SCROLL_ZOOM_BLOCKER_CTRL: 'Use ctrl + scroll to zoom the map',
    MAPBOX_SCROLL_ZOOM_BLOCKER_COMMAND: 'Use ⌘ + scroll to zoom the map',
    SUBMIT_AGAIN: 'Submit again',
    OTHER_ITEMS: 'Other',
    MAIN_H1: 'Create an interactive map in a minute',
    MAIN_H2: 'Share it, Embed it, Sell it. As you want. No registration needed',
    YOUR_POSSIBILITIES: 'Your possibilities',
    GET_YOUR_INSPIRATION: 'Get your inspiration',
    NAME_YOUR_MAP: 'Name your map',
    AGREE_WITH: 'I agree with',
    TERMS_AND_CONDITIONS: 'terms and conditions',
    CREATE_YOUR_MAP: 'Create your map',
    HERO_BLOCK1_H1: 'Pick your style',
    HERO_BLOCK1_P1: 'Pick a map style you like. There are lots of different styles to choose from that fit your needs and match your brand. You can even upload your own map as an image and add interactive markers on it',
    HERO_BLOCK2_H1: 'Add any markers',
    HERO_BLOCK2_P1: 'Show off your creative side. You can add markers like pins, pictures, shapes, paths, and lines to your map. There is also a ready to use library of AI generated images and icons to choose from',
    HERO_BLOCK3_H1: 'Make it interactive',
    HERO_BLOCK3_P1: 'Every marker you put on your map can be made interactive. When your visitors click on it, they can see your text, pictures, links, videos, and more. This way, you can easily provide extra value for them',
    TRAVELLING: 'Travelling',
    CABIN_MAP: 'Cabin map',
    CITY_MAP: 'City map',
    FOOD_FESTIVAL: 'Food festival',
    FESTIVALS: 'Festivals',
    MUSIC_FESTIVAL: 'Music festival',
    FAIRS: 'Fairs',
    JOB_FAIR: 'Job fair',
    THEME_PARKS: 'Theme parks',
    FAMILY_PARK: 'Family park',
    CONFERENCES: 'Conferences',
    CONFERENCE: 'Conference',
    BUSINESS: 'Business',
    CUSTOMER_MAP: 'Customer map',
    SPORT: 'Sport',
    RUNNING_RACE: 'Running race',
    TRONDHEIM_NORWAY: 'Trondheim, Norway',
    GOTA_FAROE_ISLANDS: 'Gota, Faroe Islands',
    TYDAL_NORWAY: 'Tydal, Norway',
    LIBEREC_CZECHIA: 'Liberec, Czechia',
    AGDER_NORWAY: 'Agder, Norway',
    AARHUS_DENMARK: 'Aarhus, Denmark',
    NAMSSKOGAN_NORWAY: 'Namsskogan, Norway',
    HEMSEDAL_NORWAY: 'Hemsedal, Norway',
    BRNO_CZECHIA: 'Brno, Czechia',
    CHOOSE_YOUR_STYLE: 'Choose your style',
    CLASSIC: 'Classic',
    SATELLITE: 'Satellite',
    OUTDOORS: 'Outdoors',
    DARK: 'Dark',
    LIGHT: 'Light',
    COLORED: 'Colored',
    IMAGE_MAP: 'Image map',
    UPLOADING: 'Uploading',
    BACK: 'Back',
    I_LIKE_THIS_ONE: 'I like this one',
    CONGRAT_TITLE: 'Congratulation, your map is created!',
    CONGRAT_DESC: 'Now add some markers to highlight your locations',
    MARKER_SELECTION: 'Marker selection',
    MARKER_SELECTION_DESC: 'Choose markers from the bottom',
    STYLING: 'Styling',
    STYLING_DESC: 'Style markers on the right',
    START_ACTION: 'Start adding markers',
    CREATING_PROMPT1: 'Hello!',
    CREATING_PROMPT1_DESC: 'You are making a great map! Do not lose your progress when you leave. Get an account now for free',
    CREATING_PROMPT2: 'Do you want more features?',
    CREATING_PROMPT2_DESC: 'Join our waitlist and be among the first ones to get more map possibilities!',
    JOIN_ACTION: 'Join',
    ALREADY_CREATING: 'You are already creating map',
    CONTINUE_CREATING: 'Continue creating',
    ALL: 'All',
    EAT: 'Eat',
    EXPLORE: 'Explore',
    EXPERIENCE: 'Experience',
    LEARN: 'Learn',
    LANDING_TITLE: 'Welcome to Mapheim editor! (Beta)',
    LANDING_DESCRIPTION: 'You have 2 options to create. You can either create a complete solution (an on-site web application with an optional interactive map). Or you can create and use interactive map alone',
    LANDING_ITEM1: 'Choose what you want to create',
    LANDING_ITEM2: 'Let us know if you have any questions or feedback',
    LANDING_ITEM3: 'We recommend that you login so you do not lose your progress!',
    GUIDES: 'Guides',
    GUIDES_DESC: 'On-site application with an optional interactive map',
    EDIT_GUIDE_NO_LOGIN: 'Edit your guide without logging in',
    CREATE_GUIDE_NO_LOGIN: 'Create your guide without logging in',
    NEW_GUIDE_TITLE: 'New guide',
    NEW_MAP_TITLE: 'New map',
    NEW_GUIDE_MESSAGE: 'Scan the QR code to access the app on your mobile. You can then enjoy the event to the fullest',
    INTERACTIVE_MAPS: 'Interactive maps',
    INTERACTIVE_MAPS_DESC: 'Standalone interactive map',
    EDIT_MAP_NO_LOGIN: 'Edit your map without logging in',
    CREATE_MAP_NO_LOGIN: 'Create your map without logging in',
    CREATE_GUIDE: 'Create guide',
    GUIDE_NAME: 'Guide name',
    ACTIONS: 'Actions',
    MAP_NAME: 'Map name',
    EDIT_MAP: 'Edit map',
    EDIT_DETAILS: 'Edit details',
    CREATE_MAP: 'Create map',
    CONFIGURATION: 'Configuration',
    LISTS: 'Lists',
    PROGRAM: 'Program',
    SHARE: 'Share',
    CONFIGURATION_TITLE: 'Welcome to the editor (Beta)',
    CONFIGURATION_DESC: 'Set up your on-site application and/or interactive map within a few moments',
    CONFIGURATION_ITEM1: 'Fill in basic information',
    CONFIGURATION_ITEM2: 'Decide which features you would like to have in your solution',
    CONFIGURATION_ITEM3: 'Everything in the editor is saved automatically',
    CONFIGURATION_ITEM4: 'Contact us for any questions and feedback',
    BASIC_INFORMATION: 'Basic setup',
    BASIC_INFORMATION_DESC: 'First steps for your amazing application!',
    FEATURES: 'Features',
    FEATURES_DESC: 'What would you like to have in your application?',
    OTHER_INFORMATION: 'Other information',
    EXTERNAL_LINKS: 'External links',
    EXTERNAL_LINKS_DESC: 'Links taking visitors outside the application',
    CUSTOM_FEATURES: 'Custom features and help',
    CUSTOM_FEATURES_DESC: 'Contact us to get more from your solution, such as:',
    CUSTOM_FEATURES_ITEM1: 'Your color scheme and branding',
    CUSTOM_FEATURES_ITEM2: 'Additional features and configurations',
    CUSTOM_FEATURES_ITEM3: 'Help and support with the creation',
    INFORMATION: 'Information',
    WELCOME_MESSAGE: 'Welcome message',
    COLOR_THEME: 'Color theme',
    LOGO: 'Logo',
    LISTS_DESC2: 'Lists of points of interests (e.g. Exhibitors, Animals, Restaurants)',
    PROGRAM_DESC: 'Schedule of events during a day',
    INFO_DESC: 'Classic questions and answers section',
    MAP_DESC: 'Indoor or outdoor interactive map',
    OPEN_ACTION: 'Open',
    START_DATE: 'Start date',
    END_DATE: 'End date',
    MAP_PREVIEW: 'Map preview',
    DATES: 'Dates',
    VISUAL: 'Visual',
    ASK_REMOVE_LINK: 'Do you want to delete this link?',
    URL: 'URL',
    MESSAGE: 'Message',
    SEND_EMAIL: 'Send email',
    EMAIL_SENT1: 'Email sent!',
    EMAIL_SENT2: 'Something went wrong',
    EMAIL_SENT1_DESC: 'We will get back to you as soon as possible',
    EMAIL_SENT2_DESC: 'Please try again or reach out to use using the bubble in the corner',
    CLONE_GUIDE: 'Clone guide',
    CLONING: 'Cloning',
    CLONE_MESSAGE: 'All the content will be copied from this guide, including the map. Your current guide will not be affected. Do you want to clone this guide?',
    DELETE_GUIDE: 'Delete guide',
    DELETING: 'Deleting',
    DELETE_MESSAGE: 'This action is irreversible. All your content, including the map will be deleted. Are you sure you want to delete the guide?',
    CANCEL: 'Cancel',
    CONFIRM: 'Confirm',
    NEW_DETAIL: 'New detail',
    DETAIL_CREATED: 'Detail created!',
    CATEGORY_CREATED: 'Category created!',
    DONE: 'Done',
    DETAILS_TITLE: 'Edit your details',
    DETAILS_DESC: 'This is the place where you can add all the details for your application. Fill in data (text, images, links, etc.) for your Lists, Program, Information and Map. Then you can link them together in other pages.',
    DETAILS_ITEM1: 'Add all the details for your application',
    DETAILS_ITEM2: 'Add categories to use for filters',
    DETAILS_DESC2: 'Add all the details for your application',
    CREATING: 'Creating',
    CREATE_DETAIL: 'Create detail',
    NOT_USED: 'Not used',
    FILTER: 'Filter',
    CREATE_CATEGORY: 'Create category',
    CATEGORIES_DESC: 'Add categories to use for filters (e.g. "Types of Exhibitors", "Different rooms", etc.)',
    ASK_DELETE_DETAIL: 'Do you want to delete this detail?',
    USAGE: 'Usage',
    ASK_DELETE_CATEGORY: 'Do you want to delete this category?',
    QUICK_ASSIGN_LISTS: 'Quick assign to Lists and Info',
    EDIT_CATEGORIES: 'Edit categories',
    NO_CATEGORIES: 'No categories found. Create them first in Details',
    GO_TO_DETAILS: 'Go to Details',
    EDIT_CATEGORY: 'Edit category',
    BACK_TO_DETAILS: 'Back to Details',
    EDIT_DETAIL: 'Edit this detail',
    EDIT_DETAIL_DESC: 'Fill in the information for this detail. Do not forget to add many cards to make it interesting and more relevant for your visitors.',
    EDIT_DETAIL_ITEM1: 'Fill in header information: Title, description and image',
    EDIT_DETAIL_ITEM2: 'Add many cards with rich content (links, images, videos, etc.)',
    EDIT_DETAIL_ITEM3: 'Watch the preview on the right to see how it is looking',
    EDIT_DETAIL_ITEM4: 'Everything is saved automatically',
    HEADER_DETAIL: 'Header',
    HEADER_DETAIL_DESC: 'Add the core information for this detail. Do not forget to add some cards after this',
    CONTENT_DETAIL: 'Content',
    CONTENT_DETAIL_DESC: 'Pick from a variety of cards to add rich content to this detail',
    LIVE_PREVIEW: 'Live preview',
    STRETCH_IMAGE: 'Stretch image',
    GIF_CARD: 'GIF card',
    ASK_DELETE_IMAGE: 'Do you want to delete this image?',
    IMAGE_CARD: 'Image card',
    LINK_CARD: 'Link card',
    LINKED_STORIES_CARD: 'Linked details card',
    TEXT_CARD: 'Text card',
    ASK_DELETE_CARD: 'Do you want to delete this card?',
    OPEN_YOUTUBE: 'Open YouTube',
    OPEN_FACEBOOK: 'Open Facebook',
    OPEN_TWITTER: 'Open Twitter',
    OPEN_INSTAGRAM: 'Open Instagram',
    CREATE_LISTS_TITLE: 'Create different lists of details',
    CREATE_LISTS_DESC: 'You can create one or more lists such as restaurants, shops, exhibitors, etc. Assign the details to the lists',
    CREATE_LISTS_ITEM1: 'Create lists of details',
    CREATE_LISTS_ITEM2: 'Set up their properties',
    CREATE_LISTS_ITEM3: 'Assign details to the lists',
    LISTS_DESC: 'Manage the properties and details in your lists',
    CREATE_LIST: 'Create list',
    THIS_PREVIEW: 'This is a preview',
    THIS_PREVIEW_DESC: 'Open on your phone live',
    OPEN_IN_TAB: 'Open in new tab',
    ASK_DELETE_LIST: 'Do you want to delete this list?',
    LINKED_DETAILS: 'Linked details',
    LINK_DETAILS: 'Link details',
    NO_DETAILS: 'There are no details to link. Create them first in Details',
    SEARCH_DETAILS: 'Search details',
    NO_OPTIONS: 'No options',
    EDIT_LIST: 'Edit list',
    LINK_TEXT: 'Link text',
    LINK_URL: 'Link URL',
    LINK_TO_MAP: 'Link to map',
    SEARCHABLE: 'Searchable',
    MODIFY_PROGRAM: 'Modify program',
    MODIFY_PROGRAM_DESC: 'Add, edit or delete events in the program. You can assign categories to them, link them to the details or map marker',
    MODIFY_PROGRAM_ITEM1: 'Add programme items',
    MODIFY_PROGRAM_ITEM2: 'Assign details to each programme item',
    MODIFY_PROGRAM_ITEM3: 'Link them to the map marker',
    EVENTS: 'Events',
    EVENTS_DESC: 'Manage the events and their details',
    CREATE_EVENT: 'Create event',
    ASK_REMOVE_EVENT: 'Do you want to delete this event?',
    IN_MAP: 'In map',
    DATE: 'Date',
    EDIT_EVENT: 'Edit event',
    AUTOFILL_INFO: 'Autofill title and description from linked detail',
    TIME_START: 'Time start',
    TIME_END: 'Time end',
    MAP_LOCATION: 'Map location',
    SELECT_MARKER: 'Select marker',
    NO_MAP_LOCATIONS: 'No map locations found. Create them first in Map',
    GO_TO_MAP: 'Go to Map',
    MODIFY_INFORMATION: 'Modify information',
    MODIFY_INFORMATION_DESC: 'Guide your visitors by providing questions and answers. Each topic is a linked detail',
    MODIFY_INFORMATION_ITEM1: 'Assign details to the information section',
    INFORMATION_DESC: 'Assign details to display in the information section',
    CREATE_MAP_TITLE: 'Create interactive map',
    CREATE_MAP_DESC: 'You have a possibility to have a great interactive map to guide your visitors. It can be geographical, indoor, artistic or image-based. The map can be done in our editor, but we usually help our customers.',
    CREATE_MAP_ITEM1: 'Contact us for map requests or edit the map in the editor',
    INTERACTIVE_MAP_DESC: 'Map editor opens in a new tab',
    OPEN_EDITOR: 'Open editor',
    SHARE_APPLICATION: 'Share your application',
    SHARE_APPLICATION_DESC: 'You can share your application either via link or QR code. The map can be also included in your website or application directly.',
    SHARE_APPLICATION_ITEM1: 'Print QR codes and place them in your area or on your materials',
    SHARE_APPLICATION_ITEM2: 'Share the link on your website and social media',
    SHARE_THE_APPLICATION: 'Share the application',
    SHARE_THE_APPLICATION_DESC: 'Distribute QR codes and links to your visitors',
    COPY_LINK: 'Copy link',
    COPY: 'Copy',
    OPEN_LINK: 'Open link',
    DOWNLOAD_QR: 'Download QR code',
    QR_CODE: 'QR code',
    EMBEDDED_MAP_IFRAME: 'Embedded map iframe',
    FORMS: 'Forms',
    FORM_SUBMISSIONS: 'Form submissions',
    FORMS_DESC: 'Connect forms to your guides',
    MAP_V2_SEARCH_THIS_MAP: 'Search this map',
    MAP_V2_COLLAPSE: 'Collapse',
    MAP_V2_EXPAND: 'Expand',
    MAP_V2_GO_BACK: 'Go back',
    MAP_V2_GOOGLE_MAPS_NAVIGATION: 'Google Maps navigation',
    MAP_V2_ALL_PLACES: 'All places',
    MAP_V2_SELECTED_GROUP: 'Selected group',
    MAP_V2_CATEGORY_SHOW_ALL: 'Show all',
    MAP_V2_CATEGORY_HIGHLIGHTS: 'Highlights',
    MAP_V2_CATEGORY_HERITAGE: 'Heritage',
    MAP_V2_CATEGORY_DINING: 'Dining',
    MAP_V2_CATEGORY_FUN: 'Fun',
    MAP_V2_CATEGORY_ART: 'Art',
    MAP_V2_CATEGORY_EVENTS: 'Events',
    MAP_V2_PLACES_POSTFIX: 'places',
    MAP_V2_FULLSCREEN_TURN_OFF: 'Exit fullscreen',
    MAP_V2_FULLSCREEN_TURN_ON: 'Switch map to fullscreen'
};
